export default "__VITE_ASSET__CVtwWQ$P__"